/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from 'react';
import { UsersListContainer } from './container';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import RouteConfig from '@/AppNavigator/services/config/routes.config.json';

const SwalWithBootstrapButtons = withReactContent(
  Swal.mixin({
    customClass: {
      confirmButton: 'btn btn-primary me-3',
      cancelButton: 'btn btn-secondary',
    },
    buttonsStyling: false,
  })
);

export const UsersListPage = ({ navigation }: { navigation: any }) => {
  const navigate = useNavigate();

  // const _onGoback = async () => {
  //   const textMessage = 'By exiting application will be moved to draft';
  //   const result = await SwalWithBootstrapButtons.fire({
  //     icon: 'error',
  //     title: 'Confirm Back',
  //     text: textMessage,
  //     allowOutsideClick: false,
  //     showCancelButton: true,
  //     confirmButtonText: 'Yes',
  //     cancelButtonText: 'Cancel',
  //   });

  //   if (result.isConfirmed) {
  //     navigate(-1);
  //   }
  // };

  return (
    <UsersListContainer
      goBack={() => navigate(-1)}
      onPaymentClick={() => navigate('/payment')}
      // onRenewClick={(data: any) =>     navigate(`${RouteConfig?.routes?.RenewApplication?.path}?id=${data}`)}

      onRenewClick={(applicationNo: any) =>
        navigate(
          `${RouteConfig?.routes?.Application?.path}?id=${applicationNo}`,
          {
            state: { from: 'renew' },
          }
        )
      }
      // onViewClick={(id: string) => history.push(`/users/${id}`)}
      onTerminateSuccess={() => navigate('/work-permits')}
    />
  );
};
